import React from 'react'
import { Text } from '@vtex/shoreline'
import { IoSparklesSharp } from 'react-icons/io5'

import * as S from './styles'

interface AlertCustomProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string
  variant?: 'ai'
}

export const AlertCustom = ({
  text,
  variant = 'ai',
  ...rest
}: AlertCustomProps) => {
  const Icon = { ai: IoSparklesSharp }[variant]

  return (
    <S.Container gap="var(--sl-space-2)" align="center" {...rest}>
      <div style={{ minWidth: '12px', minHeight: '12px' }}>
        <Icon
          size={12}
          color="color-mix(in srgb, var(--primary) 50%, transparent)"
        />
      </div>
      <Text variant="body">{text}</Text>
    </S.Container>
  )
}
